<template>
    <h4 class=" cb-text-h4 mb-6 ">Transactions</h4>

    <Tabs />

    <div class="filters flex gap-4 mb-6 mt-4">




        <div v-click-outside="()=>onClickOutside(0)" class="form-control w-min">
            <div @click="Option[0]= !Option[0]" class="form-control w-auto">
                <div @click="Option1= !Option1" class="mt-1  relative">
                    <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                        aria-labelledby="listbox-label">
                        <span class="w-full inline-flex truncate">
                            <span class="select-secondary-text">Period:</span>
                            <span class="truncate ml-1 black font-medium"> All time </span>
                        </span>
                        <span class="select-button-icon-container">
                            <!-- Heroicon name: solid/selector -->
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                    clip-rule="evenodd" />
                            </svg>
                        </span>
                    </button>
                </div>
            </div>
            <ul tabindex="-1" v-show="Option[0]" class="select-ul max-w-[180px] !h-auto !max-h-fit" role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">

                <li class="select-li-selected group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> All time </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Yesterday </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 1 week </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 1 month </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 3 months </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 6 months </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">

                    <span class="font-normal block truncate"> Last 1 year </span>

                    <span class="select-li-icon ">
                        <!-- Heroicon name: solid/check -->
                    </span>
                </li>

                <!-- More items... -->
            </ul>
        </div>



        <div v-click-outside="()=>onClickOutside(1)" class="form-control w-auto">
            <div @click="Option[1]= !Option[1]" class="mt-1  relative">
                <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                    aria-labelledby="listbox-label">
                    <span class="w-full inline-flex truncate">
                        <span class="select-secondary-text">Status:</span>
                        <span class="truncate ml-1 black font-medium"> All </span>
                    </span>
                    <span class="select-button-icon-container">
                        <!-- Heroicon name: solid/selector -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </button>
            </div>
            <ul tabindex="-1" v-show="Option[1]" class="select-ul max-w-[196px] !h-auto !max-h-fit" role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="In Progress" aria-describedby="comments-description" name="In Progress" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="In Progress" class="text-gray-700 label">In Progress</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Success" aria-describedby="comments-description" name="Success" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Success" class="text-gray-700 label">Success</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Void" aria-describedby="comments-description" name="Void" checked type="checkbox"
                                class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Void" class="text-gray-700 label">Void</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Failed" aria-describedby="comments-description" name="Failed" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Failed" class="text-gray-700 label">Failed</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Timeout" aria-describedby="comments-description" name="Timeout" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Timeout" class="text-gray-700 label">Timeout</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Needs Attention" aria-describedby="comments-description" name="Needs Attention"
                                checked type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Needs Attention" class="text-gray-700 label">Needs Attention</label>
                        </div>
                    </div>
                </li>


                <!-- More items... -->
            </ul>
        </div>

        <div v-click-outside="()=>onClickOutside(2)" class="form-control w-auto">
            <div @click="Option[2]= !Option[2]" class="mt-1  relative">
                <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                    aria-labelledby="listbox-label">
                    <span class="w-full inline-flex truncate">
                        <span class="select-secondary-text">Type:</span>
                        <span class="truncate ml-1 black font-medium"> All </span>
                    </span>
                    <span class="select-button-icon-container">
                        <!-- Heroicon name: solid/selector -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </button>
            </div>
            <ul tabindex="-1" v-show="Option[2]" class="select-ul max-w-[216px] !h-auto !max-h-fit" role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Authorization" aria-describedby="comments-description" name="Authorization"
                                checked type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Authorization" class="text-gray-700 label">Authorization</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Payment" aria-describedby="comments-description" name="Payment" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Payment" class="text-gray-700 label">Payment</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Refund" aria-describedby="comments-description" name="Refund" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Refund" class="text-gray-700 label">Refund</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Payment Reversal" aria-describedby="comments-description" name="Payment Reversal"
                                checked type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Payment Reversal" class="text-gray-700 label">Payment Reversal</label>
                        </div>
                    </div>
                </li>



                <!-- More items... -->
            </ul>
        </div>

        <div v-click-outside="()=>onClickOutside(3)" class="form-control w-auto">
            <div @click="Option[3]= !Option[3]" class="mt-1  relative">
                <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                    aria-labelledby="listbox-label">
                    <span class="w-full inline-flex truncate">
                        <span class="select-secondary-text">Amount:</span>
                        <span class="truncate ml-1 black font-medium"> All </span>
                    </span>
                    <span class="select-button-icon-container">
                        <!-- Heroicon name: solid/selector -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </button>
            </div>
        </div>

        <div v-click-outside="()=>onClickOutside(4)" class="form-control w-auto">
            <div @click="Option[4]= !Option[4]" class="mt-1  relative">
                <button class="select-button" aria-haspopup="listbox" aria-expanded="true"
                    aria-labelledby="listbox-label">
                    <span class="w-full inline-flex truncate">
                        <span class="select-secondary-text">Payment method:</span>
                        <span class="truncate ml-1 black font-medium"> All </span>
                    </span>
                    <span class="select-button-icon-container">
                        <!-- Heroicon name: solid/selector -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </span>
                </button>
            </div>

            <ul tabindex="-1" v-show="Option[4]" class="select-ul max-w-[216px] !h-auto !max-h-fit" role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="Card" aria-describedby="comments-description" name="Card" checked type="checkbox"
                                class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="Card" class="text-gray-700 label">Card</label>
                        </div>
                    </div>
                </li>

                <li class="select-li group" id="listbox-option-0" role="option">
                    <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                            <input id="ACH Credit" aria-describedby="comments-description" name="ACH Credit" checked
                                type="checkbox" class="checkbox">
                        </div>

                        <div class="ml-3 cb-text-copy-small">
                            <label for="ACH Credit" class="text-gray-700 label">ACH Credit</label>
                        </div>
                    </div>
                </li>


                <!-- More items... -->
            </ul>
        </div>

    </div>

    <Table />

</template>

<script>
import Tabs from "./Tabs.vue";
import vClickOutside from 'click-outside-vue3'
import Table from './Table.vue'


export default {
    name: "Transactions",
    components: {
    Tabs,
    Table
},
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        onClickOutside(param) {
            this.Option[param] = false
        }
    },
    data() {
        return {
            Option: [false,false,false,false,false],
   
        }
    }
};

</script>